function PoleSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 200"
      width="8"
      height="40"
      className=""
    >
      <rect x="50" y="-180" width="16" height="580" fill="rgb(0 0 0 / 0.35)" />
    </svg>
  );
}

export default PoleSvg;
